export let webLicense = [{
    name: "Laravel",
    type: "MIT",
    url: "https://github.com/laravel/framework/blob/master/LICENSE.md",
}, {
    name: "laravel-dompdf",
    type: "MIT",
    url: "https://github.com/barryvdh/laravel-dompdf/blob/master/LICENSE"
},
{
    name: "Laravel Enum",
    type: "MIT",
    url: "https://github.com/BenSampo/laravel-enum/blob/master/LICENCE.txt"
},
{
    name: "laravel-cors",
    type: "MIT",
    url: "https://github.com/fruitcake/laravel-cors/blob/master/LICENSE"
},
{
    name: "guzzle",
    type: "MIT",
    url: "https://github.com/guzzle/guzzle/blob/master/LICENSE"
},
{
    name: "Laravel Sanctum",
    type: "MIT",
    url: "https://github.com/laravel/sanctum/blob/master/LICENSE.md"
},
{
    name: "Laravel Tinker",
    type: "MIT",
    url: "https://github.com/laravel/tinker/blob/master/LICENSE.md"
},
{
    name: "Laravel UI",
    type: "MIT",
    url: "https://github.com/laravel/ui/blob/master/LICENSE.md"
},
{
    name: "laravel-azure-storage",
    type: "MIT",
    url: "https://github.com/matthewbdaly/laravel-azure-storage/blob/master/LICENSE"
},
{
    name: "Laravel Permission",
    type: "MIT",
    url: "https://github.com/spatie/laravel-permission/blob/main/LICENSE.md"
},
{
    name: "laravel-ignition",
    type: "MIT",
    url: "https://github.com/facade/ignition/blob/main/LICENSE.md"
},
{
    name: "Faker",
    type: "MIT",
    url: "https://github.com/FakerPHP/Faker/blob/main/LICENSE"
},
{
    name: "Laravel Sail",
    type: "MIT",
    url: "https://github.com/laravel/sail/blob/master/LICENSE.md"
},
{
    name: "Mockery",
    type: "MIT",
    url: "https://github.com/mockery/mockery/blob/master/LICENSE"
},
{
    name: "Collision",
    type: "MIT",
    url: "https://github.com/nunomaduro/collision/blob/stable/LICENSE.md"
},
{
    name: "Phpunit",
    type: "MIT",
    url: "https://github.com/sebastianbergmann/phpunit/blob/master/LICENSE"
},
{
    name: "Element",
    type: "MIT",
    url: "https://github.com/ElemeFE/element/blob/dev/LICENSE"
},
{
    name: "Vue",
    type: "MIT",
    url: "https://github.com/vuejs/core/blob/main/LICENSE"
},
{
    name: "Vuex",
    type: "MIT",
    url: "https://github.com/vuejs/vuex/blob/main/LICENSE"
},
{
    name: "Vue3 ChartJS Wrapper",
    type: "MIT",
    url: "https://github.com/J-T-McC/vue3-chartjs/blob/main/LICENSE"
},
{
    name: "Vue3 Slider",
    type: "MIT",
    url: "https://github.com/vueform/slider/blob/main/LICENSE.md"
},
{
    name: "axios",
    type: "MIT",
    url: "https://github.com/axios/axios/blob/master/LICENSE"
},
{
    name: "chart.js",
    type: "MIT",
    url: "https://github.com/chartjs/Chart.js/blob/master/LICENSE.md"
},
{
    name: "core-js",
    type: "MIT",
    url: "https://github.com/zloirock/core-js/blob/master/LICENSE"
},
{
    name: "moment",
    type: "MIT",
    url: "https://github.com/moment/moment/blob/develop/LICENSE"
},
{
    name: "node-sass",
    type: "MIT",
    url: "https://github.com/sass/node-sass/blob/master/LICENSE"
},
{
    name: "sass",
    type: "MIT",
    url: "https://github.com/sass/dart-sass/blob/main/LICENSE"
},
{
    name: "sass-loader",
    type: "MIT",
    url: "https://github.com/webpack-contrib/sass-loader/blob/master/LICENSE"
},
{
    name: "SVG sprite loader",
    type: "MIT",
    url: "https://github.com/JetBrains/svg-sprite-loader/blob/master/LICENSE"
},
{
    name: "TypeScript loader for webpack",
    type: "MIT",
    url: "https://github.com/TypeStrong/ts-loader/blob/main/LICENSE"
},
{
    name: "vue-router",
    type: "MIT",
    url: "https://github.com/vuejs/router/blob/main/LICENSE"
},
{
    name: "vue-slider-component",
    type: "MIT",
    url: "https://github.com/NightCatSama/vue-slider-component/blob/master/LICENSE"
},
{
    name: "Vue UUID",
    type: "MIT",
    url: "https://github.com/VitorLuizC/vue-uuid/blob/master/LICENSE"
}];

export let pcLicense = [{
    name: ".NET",
    type: "MIT",
    url: "https://dot.net/",
}, {
    name: ".NET Runtime",
    type: "MIT",
    url: "https://github.com/dotnet/runtime"
},
{
    name: "Azure SDK for .NET",
    type: "MIT",
    url: "https://github.com/Azure/azure-sdk-for-net"
},
{
    name: "Azure Storage SDK for .NET",
    type: "Apache 2.0",
    url: "https://github.com/Azure/azure-storage-net"
},
{
    name: "DotNetty",
    type: "MIT",
    url: "https://github.com/Azure/DotNetty/"
},
{
    name: "Hardcodet NotifyIcon for WPF",
    type: "CPOL",
    url: "https://github.com/hardcodet/wpf-notifyicon"
},
{
    name: "Math.NET Numerics",
    type: "MIT",
    url: "https://numerics.mathdotnet.com/"
},
{
    name: "Microsoft Edge WebView2",
    type: "BSD 2",
    url: "https://aka.ms/webview"
},
{
    name: "Newtonsoft Json.NET",
    type: "MIT",
    url: "https://www.newtonsoft.com/json"
},
{
    name: "OpenCvSharp",
    type: "BSD 2",
    url: "https://github.com/shimat/opencvsharp"
},

];




